import { createAsyncThunk } from "@reduxjs/toolkit";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import {
  deleteAccess,
  updateAccess,
  addAccess,
  getAccess,
} from "store/services/membersAndRoles/permission";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Cities
export const GetAllAccessAction = createAsyncThunk(
  "access/getAllAccess",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getAccess(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      //    ;
      return rejectWithValue(error);
    }
  },
);

//Delete City
export const DeleteAccessAction = createAsyncThunk(
  "access/deleteAccess",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;   
    try {
      const res = await deleteAccess(rest);
      if (res.status === 1) {
        const response = await getAccess(filter);
        if (response.status === 1) {
          onSuccess?.(response);                          
          return fulfillWithValue(response);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      onError?.(res);                                       
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      onError?.(error);                                  
      return rejectWithValue(error);
    }
  }
);

//Update City
export const UpdateAccessAction = createAsyncThunk(
  "access/updateAccess",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const res = await updateAccess(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

//Add City
export const AddAccessAction = createAsyncThunk(
  "access/addAccess",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await addAccess(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        window.location = "/access-management/permission";
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
